import Body from './Body';

type components = {
  Body: typeof Body;
}

const Components: components = {
  Body,
}

export default Components;
